import { POST } from 'api/index';
import { AlertInterface } from 'entities/interfaces';

export const useChatFeedback = (
  token: string,
  activeId: number,
  setNpsSubmitted: React.Dispatch<React.SetStateAction<boolean>>,
  setAlert?: (alert: AlertInterface) => void
) => {
  const handleFeedback = async (courseId: number, feedback: number) => {
    try {
      const body = new URLSearchParams();
      body.append('userToken', token);
      body.append('sectionId', courseId.toString());
      body.append('score', feedback.toString());

      const response = await POST('setNetPromoterScore', body);

      if (response.status === 200) {
        localStorage.setItem(`npsSubmitted_${activeId}`, 'true');
        setNpsSubmitted(true);

        if (setAlert) {
          setAlert({ color: 'success', message: 'Feedback erfolgreich gespeichert!' });
        }
      } else {
        if (setAlert) {
          setAlert({ color: 'error', message: 'Fehler beim Speichern des Feedbacks' });
        }
      }
    } catch (error) {
      console.error("Fehler beim Senden des Feedbacks:", error);
      if (setAlert) {
        setAlert({ color: 'error', message: 'Netzwerkfehler beim Feedback' });
      }
    }
  };

  return {
    handleFeedback
  };
};
